import DoctorWallet from '../../doctor/wallet/Wallet';

const ClinicWallet = () => {
  return <DoctorWallet />;
};

export default ClinicWallet;
